import { render, staticRenderFns } from "./RequestRow.vue?vue&type=template&id=2f56cca8"
import script from "./RequestRow.vue?vue&type=script&lang=js"
export * from "./RequestRow.vue?vue&type=script&lang=js"
import style0 from "./RequestRow.vue?vue&type=style&index=0&id=2f56cca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports